import React, { useState, useEffect, useRef } from 'react';
import './Home.css'; // Ensure this points to the final CSS file

// --- Single Placeholder Image ---
import ServicePage from '../Service/Service';
import DirectorsSection from '../Director/Director';
// --- Placeholder Images (UPDATE PATHS FOR INTRO 2 & 3) ---
import placeholderImage from '../Assets/hero4.png'; // Used for all sections currently
 import introImage1 from '../Assets/hero1.png';
 import introImage2 from '../Assets/hero2.png';
 import introImage3 from '../Assets/hero3.png';
import parallaxImage from '../Assets/8.png'; // Separate variable for parallax if needed
import one from "../Assets/1.png"


// --- Placeholder Icons (Replace with actual icons) ---
const IconPlaceholder = ({ className = '' }) => <span className={`icon-placeholder ${className}`}>✦</span>;

// --- Hero Carousel Data (Keep as is) ---
const heroImages = [introImage2, introImage3, placeholderImage, introImage1];
const heroTransitionTypes = ['fade', 'slide-left', 'zoom-in', 'slide-up'];

// --- Intersection Observer Hook (Keep as is) ---
const useVisibility = (options) => {
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef(null);
    const [hasBeenVisible, setHasBeenVisible] = useState(false);

    const callbackFunction = (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !hasBeenVisible) {
             setIsVisible(true);
             setHasBeenVisible(true); // Animate only once
        }
        // Optional: Reset visibility (commented out by default)
        // else if (!entry.isIntersecting && hasBeenVisible) {
        //     setIsVisible(false);
        //     // setHasBeenVisible(false); // Uncomment for re-animation
        // }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(callbackFunction, options);
        const currentElement = elementRef.current;
        if (currentElement) observer.observe(currentElement);
        return () => { if (currentElement) observer.unobserve(currentElement); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elementRef, options]);

    return [elementRef, isVisible];
};


function Home() {
    // --- Hero State & Logic (Keep as is) ---
    const [currentHeroIndex, setCurrentHeroIndex] = useState(0);
    const [currentTransition, setCurrentTransition] = useState(heroTransitionTypes[0]);
    const [previousHeroIndex, setPreviousHeroIndex] = useState(null);
    const isTransitioning = useRef(false);

    useEffect(() => {
        const timer = setInterval(() => {
            if (isTransitioning.current) return;
            isTransitioning.current = true;
            const nextIndex = (currentHeroIndex + 1) % heroImages.length;
            const nextTransition = heroTransitionTypes[nextIndex % heroTransitionTypes.length];
            setPreviousHeroIndex(currentHeroIndex);
            setCurrentTransition(nextTransition);
            setCurrentHeroIndex(nextIndex);
            setTimeout(() => {
                 setPreviousHeroIndex(null);
                 isTransitioning.current = false;
            }, 1500);
        }, 5000);
        return () => clearInterval(timer);
    }, [currentHeroIndex]);

    // --- Scroll Animation Hooks (Keep as is) ---
    const [aboutSectionRef, isAboutSectionVisible] = useVisibility({ threshold: 0.3 });
    const [servicesSectionRef, areServicesVisible] = useVisibility({ threshold: 0.2 });
    const [whyChooseSectionRef, isWhyChooseVisible] = useVisibility({ threshold: 0.25 });
    const [parallaxContentRef, isParallaxContentVisible] = useVisibility({ threshold: 0.5 });
    const [specialtiesSectionRef, areSpecialtiesVisible] = useVisibility({ threshold: 0.2 }); // Slightly increased threshold for fix

    return (
        <div className="home-container">
            {/* ============================================= */}
            {/* === Hero Section (KEEP EXISTING STYLES) === */}
            {/* ============================================= */}
            <header className="hero-section">
                <div className="hero-bg-container">
                    {heroImages.map((img, index) => (
                        <div key={index} className={`hero-bg-layer ${index === currentHeroIndex ? `active ${currentTransition}-enter-active` : ''} ${index === previousHeroIndex ? `previous ${currentTransition}-exit-active` : ''}`} style={{ backgroundImage: `url(${img})` }} />
                    ))}
                </div>
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <h1 className="hero-headline"><span>Elevating</span> <span>Healthcare</span> <span>Together</span></h1>
                    <p className="hero-subheadline animate-pop-in delay-3">Your trusted partner in comprehensive healthcare solutions, connecting talent with opportunity.</p>
                    <a href="/service" className="cta-button animate-pulse delay-4">Discover Solutions<span className="cta-arrow">→</span></a>
                </div>
                 <div className="hero-decorator decorator-1"></div>
                 <div className="hero-decorator decorator-2"></div>
            </header>


            {/* ============================================= */}
            {/* === About Section (KEEP ULTRA ENHANCED) === */}
            {/* ============================================= */}
            <section
                id="about"
                className={`content-section about-section ${isAboutSectionVisible ? 'is-visible' : ''}`}
                ref={aboutSectionRef}
            >
                <div className="about-background-element blob-1"></div>
                <div className="about-background-element blob-2"></div>
                <div className="about-grid">
                    <div className="about-image-column">
                        <div className="about-image-reveal-wrapper">
                            <img src={one} alt="Synergistic healthcare network visualization" className="about-image" />
                             <div className="about-image-overlay-texture"></div>
                        </div>
                         <div className="about-floating-accent"></div>
                    </div>
                    <div className="about-content-column">
                        <h2 className="section-title about-title-animate">
                            <span>Architects</span> <span>of</span> <span>Healthcare</span> <span>Synergy</span>
                        </h2>
                        <p className="about-text-animate">
                        Established in 2019, Cliniqor Healthcare Project and Manpower Solutions was born from a vision to invigorate India's healthcare landscape. We are not merely recruiters; we are architects of opportunity, building the vital bridges that connect exceptional medical professionals with forward-thinking healthcare institutions.
                        </p>
                        <p className="about-text-animate delay-1">
                        Think of us as the central nexus for healthcare advancement. Our mission transcends simple placements; we cultivate synergistic partnerships that drive growth, foster innovation, and elevate patient care standards across the nation.
                        </p>
                        <a href="/contact" className="link-styled about-link-animate">
                            Explore Our Partnership Advantage →
                        </a>
                    </div>
                </div>
            </section>

           {/* ============================================= */}
            {/* === Directors Section  === */}
            {/* ============================================= */}
                    <DirectorsSection/>

            {/* ============================================= */}
            {/* === Services Section === */}
            {/* ============================================= */}
          <ServicePage/>

            {/* Optional Divider */}
            <div className="section-divider divider-subtle-curve"></div>

             {/* ============================================= */}
            {/* === Why Choose Us Section  === */}
            {/* ============================================= */}
            <section
                id="why-choose-us"
                className={`content-section why-choose-us-section ${isWhyChooseVisible ? 'is-visible' : ''}`}
                ref={whyChooseSectionRef}
            >
                 <h2 className="section-title why-title-animate">The Embodiment of Excellence</h2>
                <div className="why-choose-container">
                     <div className="why-choose-central-visual">
                         <div className="central-visual-core"></div>
                         <div className="central-visual-ring ring-1"></div>
                         <div className="central-visual-ring ring-2"></div>
                         <div className="central-visual-ring ring-3"></div>
                     </div>
                    <div className="why-choose-item item-1" style={{"--item-angle": "0deg", "--item-distance": "220px", "--item-delay": "0.1s"}}>
                        <div className="why-choose-icon-wrapper"><IconPlaceholder /></div>
                        <div className="why-choose-text"><h3>Unrivaled Quality</h3><p>Elite, vetted professionals.</p></div>
                    </div>
                    <div className="why-choose-item item-2" style={{"--item-angle": "90deg", "--item-distance": "220px", "--item-delay": "0.25s"}}>
                         <div className="why-choose-icon-wrapper"><IconPlaceholder /></div>
                         <div className="why-choose-text"><h3>Peak Efficiency</h3><p>Streamlined placements.</p></div>
                    </div>
                     <div className="why-choose-item item-3" style={{"--item-angle": "180deg", "--item-distance": "220px", "--item-delay": "0.4s"}}>
                         <div className="why-choose-icon-wrapper"><IconPlaceholder /></div>
                         <div className="why-choose-text"><h3>True Partnership</h3><p>Dedicated, lasting support.</p></div>
                    </div>
                     <div className="why-choose-item item-4" style={{"--item-angle": "270deg", "--item-distance": "220px", "--item-delay": "0.55s"}}>
                        <div className="why-choose-icon-wrapper"><IconPlaceholder /></div>
                         <div className="why-choose-text"><h3>Care-Centric</h3><p>Elevating patient outcomes.</p></div>
                    </div>
                </div>
            </section>


            {/* ============================================= */}
            {/* === Parallax Section (KEEP ULTRA ENHANCED) === */}
            {/* ============================================= */}
            <section className="parallax-section" style={{ backgroundImage: `url(${parallaxImage})` }}>
                 <div className="parallax-grid-lines"></div>
                 <div className="parallax-floating-shapes">
                     <div className="shape shape-a"></div><div className="shape shape-b"></div><div className="shape shape-c"></div>
                 </div>
                <div className="parallax-overlay-enhanced"></div>
                <div className={`parallax-content ${isParallaxContentVisible ? 'is-visible' : ''}`} ref={parallaxContentRef}>
                    <h2 className="parallax-headline-reveal"><span>Catalyzing</span> <span>Healthcare's</span> <span>Future</span></h2>
                    <p className="parallax-subtext-reveal">Pioneering connections that redefine standards. We empower providers and elevate patient care through strategic talent integration and unwavering commitment to excellence.</p>
                    {/* <a href="#contact" className="cta-button parallax-cta-reveal">Engage With Us</a> */}
                </div>
            </section>


            {/* ==================================================== */}
            {/* === Specialties Section (FIXED & POLISHED) === */}
            {/* ==================================================== */}
            <section
                id="specialties"
                className={`content-section specialties-section ${areSpecialtiesVisible ? 'is-visible' : ''}`}
                ref={specialtiesSectionRef}
            >
                 <div className="specialties-bg-texture"></div> {/* New texture */}
                 <h2 className="section-subtitle specialties-subtitle">Connecting Expertise Across Disciplines</h2>
                 {/* Description moved below subtitle with spacing */}
                <p className="section-description specialties-description">
                    Our network spans a vast array of medical fields, ensuring access to specialized talent including:
                </p>
                <div className="specialties-list-container">
                    {/* Columns remain the same */}
                    <ul className="specialties-list column-1">
                        {[ 'Dermatologist', 'Orthopedician', 'General Physician', 'Anesthesiology', 'Interventional Cardiologist', 'Emergency Medicine' ].map((specialty, index) => (<li key={specialty} style={{ '--delay-index': index }}>{specialty}</li>))}
                    </ul>
                    <ul className="specialties-list column-2">
                         {[ 'Nephrologists', 'Gastroenterologist', 'Endocrinologist', 'Laparoscopic Surgeon', 'ENT Surgeon', 'Urologist' ].map((specialty, index) => (<li key={specialty} style={{ '--delay-index': index + 6 }}>{specialty}</li>))}
                    </ul>
                     <ul className="specialties-list column-3">
                         {[ 'Neurophysician', 'Psychiatrist', 'Pulmonologist', 'Neurosurgeon', 'Paediatrician', 'Gastro Surgeon' ].map((specialty, index) => (<li key={specialty} style={{ '--delay-index': index + 12 }}>{specialty}</li>))}
                    </ul>
                </div>
            </section>

             {/* Optional Angled Divider */}
             <div className="section-divider divider-angled-footer"></div>

           
        </div>
    );
}

export default Home;